import { useEffect, useRef } from "react";
import goteborgImg from "../assets/goteborg-banner.jpg";

const ImageBanner = () => {
  const bgRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!bgRef.current) return;
      const scrollY = window.scrollY;
      bgRef.current.style.transform = `translateY(${scrollY * -0.2}px)`;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="relative w-full min-h-[80vh] overflow-hidden flex items-center justify-end">
      {/* Parallax background */}
      <div
        ref={bgRef}
        className="absolute inset-0 w-full"
        style={{
          backgroundImage: `url(${goteborgImg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          top:"0",
          height: "160%",
          willChange: "transform",
          transition: "transform .5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
        }}
      />

      <div className="hero-overlay absolute inset-0" />
      <div className="relative z-10 text-right pr-8 md:pr-20">
        <h2 className="font-heading text-2xl md:text-5xl tracking-wide text-foreground uppercase leading-[1.15]">
          Made by Göteborg
        </h2>
        <p className="font-body text-sm text-foreground mt-3">
          Stolt Göteborgare sedan 2013. Lokala råvaror, lokalt hjärta.
        </p>
      </div>
    </section>
  );
};

export default ImageBanner;
